import {
  Tooltip as ChakraTooltip,
  TooltipProps as ChakraTooltipProps,
  useDisclosure,
} from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

type ChildrenProps = {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
};

interface TooltipProps extends Omit<ChakraTooltipProps, 'children'> {
  children: (props: ChildrenProps) => ReactNode;
}

const Tooltip: FC<TooltipProps> = ({ children, ...props }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();

  return (
    <ChakraTooltip
      closeOnPointerDown
      isOpen={isOpen}
      placement='top'
      {...props}
    >
      {children({
        onMouseEnter: onOpen,
        onMouseLeave: onClose,
        onClick: onToggle,
      })}
    </ChakraTooltip>
  );
};

export default Tooltip;
